import React from "react";
import { X } from "react-feather";
import "./style.css";

interface AiLimitBannerProps {
    aiName: string;
    onClose?: () => void;
}

export const AiLimitBanner: React.FC<AiLimitBannerProps> = ({ aiName, onClose }) => {
    return (
        <div className="ai-limit-banner">
            <span className="ai-limit-banner-text">
                Você atingiu o limite diário de mensagens do {aiName}. As respostas voltam ao normal amanhã.
            </span>
            {onClose ? (
                <button type="button" className="ai-limit-banner-close" onClick={onClose}>
                    <X size={16} />
                </button>
            ) : null}
        </div>
    );
};

export default AiLimitBanner;
